import React from 'react';

import loadable from '@loadable/component';

import { getIsJoinEmployeeFlow } from 'features/joinEmployeeFlow/joinEmployeeFlow.utils';

const AdministratorRouter = loadable(() => import('./AdministratorRouter'));
const JoinEmployeeRouter = loadable(() => import('./JoinEmployeeRouter'));

const RootRouter: React.FC = () => {
  const isJoinEmployeeFlow = getIsJoinEmployeeFlow();

  if (isJoinEmployeeFlow) {
    return <JoinEmployeeRouter />;
  }

  return <AdministratorRouter />;
};

export default RootRouter;
